export function getQueryParam(paramName: string) {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(paramName) || '';
}
